import React from 'react';
import { User, AtSign, Shield, Calendar } from 'lucide-react';

export default function AccountStrip({ userInfo }) {
  const joined = userInfo?.joinedDate
    ? new Date(userInfo.joinedDate).toLocaleDateString()
    : '-';

  return (
    <div className="tdb-header-strip">
      <span className="chip chip--ghost">
        <User size={14} /> <strong>Name:</strong> {userInfo?.name || '-'}
      </span>
      <span className="chip chip--ghost">
        <AtSign size={14} /> <strong>Email:</strong> {userInfo?.email || '-'}
      </span>
      <span className="chip chip--ghost">
        <Shield size={14} /> <strong>Role:</strong> {userInfo?.role || '-'}
      </span>
      <span className="chip chip--muted">
        <Calendar size={14} /> <strong>Joined:</strong> {joined}
      </span>
    </div>
  );
}
